/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { skipAutoDateConversion, parseDateTime } from '../../../api-dates';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubscriptionDetailsDto as FeatureSettingsSubscriptionDetailsDto } from '../../models/feature/settings/subscription-details-dto';

export interface GetSubscriptionDetails$Params {
}

export function getSubscriptionDetails(http: HttpClient, rootUrl: string, params?: GetSubscriptionDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<FeatureSettingsSubscriptionDetailsDto>> {
  const rb = new RequestBuilder(rootUrl, getSubscriptionDetails.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context: skipAutoDateConversion(context) })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r.clone({ body: reviveResponseBody(r.body) }) as StrictHttpResponse<FeatureSettingsSubscriptionDetailsDto>;
    })
  );
}

getSubscriptionDetails.PATH = '/settings/subscription/details';

function reviveFeatureSettingsSubscriptionDetailsDto(value: any): any {
  if (value) {
    if (value["accessEndsDate"] != null) {
      value["accessEndsDate"] = parseDateTime(value["accessEndsDate"]);
    }
    if (value["dateRegistered"] != null) {
      value["dateRegistered"] = parseDateTime(value["dateRegistered"]);
    }
    if (value["upcomingInvoice"] != null) {
      value["upcomingInvoice"] = reviveFeatureSettingsUpcomingInvoiceDto(value["upcomingInvoice"]);
    }
    if (value["previousInvoices"]) {
      for (let i0 = 0; i0 < value["previousInvoices"].length; i0++) {
        if (value["previousInvoices"][i0] != null) {
          value["previousInvoices"][i0] = reviveFeatureSettingsPreviousInvoiceDto(value["previousInvoices"][i0]);
        }
      }
    }
  }
  return value;
}

function reviveFeatureSettingsUpcomingInvoiceDto(value: any): any {
  if (value) {
    if (value["billingDate"] != null) {
      value["billingDate"] = parseDateTime(value["billingDate"]);
    }
    if (value["startDate"] != null) {
      value["startDate"] = parseDateTime(value["startDate"]);
    }
    if (value["endDate"] != null) {
      value["endDate"] = parseDateTime(value["endDate"]);
    }
  }
  return value;
}

function reviveFeatureSettingsPreviousInvoiceDto(value: any): any {
  if (value) {
    if (value["startDate"] != null) {
      value["startDate"] = parseDateTime(value["startDate"]);
    }
    if (value["endDate"] != null) {
      value["endDate"] = parseDateTime(value["endDate"]);
    }
  }
  return value;
}

function reviveResponseBody(body: any): any {
  if (body != null) {
    body = reviveFeatureSettingsSubscriptionDetailsDto(body);
  }
  return body;
}
